import getImageUrl from "./getImageUrl"

const getBackgroundStyles = (image, withPosition = true, isMobile = false) => {
    let sizeQuery = ''

    if(!image) {
        return null
    }
    
    if(image.url.search("orchestrationlayer.cloudticket.net") !== -1 || image.url.search("cineorder-content-uat.cloudticket.net") !== -1 || image.url.search("contentservice.cineorder.shop") !== -1 ) {
        if(isMobile) {
            sizeQuery = "&size=500"
        } else {
            sizeQuery = "&size=2000"
        }
    }
    
    let imageUrl = image.url + sizeQuery

    // const {finalImageURl, imageUrl} = getImageUrl(image, isMobile, false)

    return ({
        backgroundImage: image && imageUrl ? `url(${imageUrl})` : 'none',
        ...(withPosition && { backgroundPositionY: (image && image.position ? image.position : '0' ) + '%' })
    })
}

export default getBackgroundStyles